import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers';

export class DetailedTaxesFeesReport extends AbstractReport {

}
AccessorsMutatorsDecorator(
    'id',
    'ident',
    'created_at',
    'created_at_tz',
    'invoice_period_from',
    'invoice_period_to',
    'nights',
    'guest_id',
    'name',
    'reservation_id',
    'reservation_ident',
    'status',
    'room_name',
    'type',
    'amount_without_taxes_fees',
    'tax_fee',
    'total_amount',
)(DetailedTaxesFeesReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/detailed-taxes-fees-report.model.js